import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n, { loadLanguageAsync } from './plugins/i18n'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from './plugins/http/axios.js'        
import pipes from './shared/pipes/pipes'          
import directives from './shared/directives/directives' 
import VueSweetalert2 from 'vue-sweetalert2'
import '@babel/polyfill'
import './assets/styles.css'

Vue.config.productionTip = false
Vue.use(VueSweetalert2)

async function bootstrap () {
  const saved = localStorage.getItem('lang') || process.env.VUE_APP_I18N_DEFAULT_LANG || 'es'
  await loadLanguageAsync(saved)
  new Vue({
    router,
    store,
    vuetify,
    directives,
    pipes,
    axios,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

bootstrap()